// extracted by mini-css-extract-plugin
module.exports = {"description":"LandingPreEco_description__1GR-R","image":"LandingPreEco_image__3cnVV","info":"LandingPreEco_info__1lBul"};